import React from 'react'
import {   Field} from 'redux-form'

export const renderFieldInput=({input, label, meta:{error, touched}})=>(<input {...input} type="input" component="input"  placeholder="aTag Placeholder"  />)

export const svtagComponent=({fields, meta:{error}})=>{
/*

({fields, meta:{error}})
*/

 return(
    <ul> 

        <li> <button onClick={()=>{fields.push()}} type="button" className="btn btn-success" >Add tag </button> </li>
   { fields.map((svTagArrayItem, idx)=>{
       console.log('tags each tag')
       console.log(svTagArrayItem)

    return(

        <li>
        <button onClick={()=>{fields.remove(idx)}} type="button" className="btn btn-success" >Remove tag </button>    
        <Field  component={renderFieldInput} name={svTagArrayItem} id={`${svTagArrayItem}`}  placeholder="ATag1" className="form-control"/>
        </li>
    )

})

   }
 <li> itemlast</li>
</ul>
 )



}

svtagComponent.displayName='SVTagComponent'